module.exports = __webpack_public_path__ + "img/img-124.ac7f72e7.png";